<template>
  <transition name="slide">
    <div
      class="profile-sidebar"
      data-cy="sidebar"
      v-if="sidebar.profile"
      v-click-outside="close"
    >
      <a
        class="profile-sidebar__close-link"
        data-cy="close-profile-sidebar-link"
        @click="close"
      >
        <cross class="profile-sidebar__close-icon" />
      </a>
      <div class="profile-sidebar__section">
        <profile-widget class="profile-sidebar__item" />
        <div
          class="profile-sidebar__item"
          @click="close"
        >
          <router-link
            to="/me/activity"
            class="profile-sidebar__link"
          >
            Meine Aktivitäten
          </router-link>
        </div>
        <div
          class="profile-sidebar__item"
          v-if="me.isTeacher && !me.readOnly"
          @click="close"
        >
          <router-link
            :to="myTeamRoute"
            data-cy="my-team-link"
            class="profile-sidebar__link"
          >
            Mein Team
          </router-link>
        </div>
      </div>
      <div class="profile-sidebar__section">
        <div class="profile-sidebar__item">
          <class-selection-widget />
          <div @click="close">
            <router-link
              :to="{ name: 'my-class' }"
              data-cy="class-list-link"
              class="profile-sidebar__link"
            >
              Klassenliste
            </router-link>
          </div>
        </div>
      </div>
      <div class="profile-sidebar__section">
        <div
          class="profile-sidebar__item"
          @click="close"
        >
          <router-link
            :to="activateAnotherLicenseRoute"
            data-cy="license-activation-link"
            class="profile-sidebar__link"
          >
            Coupon einlösen
          </router-link>
        </div>
        <div
          class="profile-sidebar__item"
          @click="close"
        >
          <router-link
            :to="joinClassRoute"
            data-cy="join-class-link"
            class="profile-sidebar__link"
          >
            Klasse beitreten
          </router-link>
        </div>
        <div class="profile-sidebar__item">
          <logout-widget />
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { useSidebar } from '@/mixins/sidebar';
import { defineAsyncComponent } from 'vue';
import ProfileWidget from '@/components/profile/ProfileWidget.vue';
import ClassSelectionWidget from '@/components/school-class/ClassSelectionWidget.vue';
import LogoutWidget from '@/components/LogoutWidget.vue';
import { MY_TEAM, JOIN_CLASS } from '@/router/me.names';
import { ADDITIONAL_LICENSE_ACTIVATION } from '@/router/auth.names';
import { useMe } from '@/graphql/queries';
const Cross = defineAsyncComponent(() => import('@/components/icons/CrossIcon.vue'));

const { sidebar, closeSidebar } = useSidebar();
const { me } = useMe();

const myTeamRoute = {
  name: MY_TEAM,
};
const joinClassRoute = {
  name: JOIN_CLASS,
};
const activateAnotherLicenseRoute = {
  name: ADDITIONAL_LICENSE_ACTIVATION,
};

const close = () => {
  closeSidebar('profile');
};
</script>

<style scoped lang="scss">
@import 'styles/helpers';

$desktop-width: 333px;

.profile-sidebar {
  padding: $large-spacing 0;
  box-sizing: border-box;
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100vh;
  background-color: $color-white;
  z-index: 15;
  box-shadow: 0 3px 9px 0 rgba(0, 0, 0, 0.12);
  overflow-y: scroll;

  width: 100%;
  @include desktop {
    width: $desktop-width;
  }

  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  &__section {
    margin-bottom: $large-spacing;

    &:last-of-type {
      margin-top: auto;
    }
  }

  &__item {
    padding: $small-spacing $medium-spacing;
  }

  &__subtitle {
    @include small-text;
    margin: 0;
    margin-bottom: $small-spacing;
  }

  &__link {
    @include default-link;
    display: block;
  }

  &__close-link {
    position: absolute;
    right: $small-spacing;
    top: $small-spacing;
    cursor: pointer;
  }
}

.slide {
  &-enter-active,
  &-leave-active {
    transition: right 0.2s;
  }

  &-enter-from,
  &-leave-to {
    right: -100vw;
    @include desktop {
      right: -$desktop-width;
    }
  }
}
</style>
